import { Marker } from "@adamscybot/react-leaflet-component-marker";
import { ScoutingMarker } from "./ScoutingMarker";
import { useSelector } from "react-redux";

export const ScoutingLayer = () => {
  const scoutingFeatures = useSelector(
    ({ resultMap }) => resultMap.scoutingFeatures
  );

  return scoutingFeatures.map((feature) => (
    <Marker
      key={feature.id}
      position={feature.coordinates}
      icon={<ScoutingMarker feature={feature} />}
    />
  ));
};
